/*
 * Generated type guards for "model.ts".
 * WARNING: Do not manually change this file.
 */
import { EOrderStatus } from '../../../../model/payment/EOrderStatus';
import { IGetPayPalOrderResponse } from './model';

export function isGetPayPalOrderResponse(obj: any, _argumentName?: string): obj is IGetPayPalOrderResponse {
  return (
    ((obj !== null && typeof obj === 'object') || typeof obj === 'function') &&
    ((obj.paypalOrder !== null && typeof obj.paypalOrder === 'object') || typeof obj.paypalOrder === 'function') &&
    ((obj.paypalOrder.data !== null && typeof obj.paypalOrder.data === 'object') ||
      typeof obj.paypalOrder.data === 'function') &&
    typeof obj.paypalOrder.data.payPalOrderId === 'string' &&
    (obj.paypalOrder.data.orderStatus === EOrderStatus.UNDEFINED ||
      obj.paypalOrder.data.orderStatus === EOrderStatus.CREATED ||
      obj.paypalOrder.data.orderStatus === EOrderStatus.SAVED ||
      obj.paypalOrder.data.orderStatus === EOrderStatus.APPROVED ||
      obj.paypalOrder.data.orderStatus === EOrderStatus.VOIDED ||
      obj.paypalOrder.data.orderStatus === EOrderStatus.COMPLETED ||
      obj.paypalOrder.data.orderStatus === EOrderStatus.PAYER_ACTION_REQUIRED) &&
    (typeof obj.paypalOrder.data.orderInfo === 'undefined' ||
      obj.paypalOrder.data.orderInfo === null ||
      (((obj.paypalOrder.data.orderInfo !== null && typeof obj.paypalOrder.data.orderInfo === 'object') ||
        typeof obj.paypalOrder.data.orderInfo === 'function') &&
        ((obj.paypalOrder.data.orderInfo.customer !== null &&
          typeof obj.paypalOrder.data.orderInfo.customer === 'object') ||
          typeof obj.paypalOrder.data.orderInfo.customer === 'function') &&
        typeof obj.paypalOrder.data.orderInfo.customer.firstName === 'string' &&
        typeof obj.paypalOrder.data.orderInfo.customer.lastName === 'string' &&
        (typeof obj.paypalOrder.data.orderInfo.customer.shippingAddress === 'undefined' ||
          obj.paypalOrder.data.orderInfo.customer.shippingAddress === null ||
          (((obj.paypalOrder.data.orderInfo.customer.shippingAddress !== null &&
            typeof obj.paypalOrder.data.orderInfo.customer.shippingAddress === 'object') ||
            typeof obj.paypalOrder.data.orderInfo.customer.shippingAddress === 'function') &&
            typeof obj.paypalOrder.data.orderInfo.customer.shippingAddress.streetName === 'string' &&
            (typeof obj.paypalOrder.data.orderInfo.customer.shippingAddress.houseNumberOrName === 'undefined' ||
              obj.paypalOrder.data.orderInfo.customer.shippingAddress.houseNumberOrName === null ||
              typeof obj.paypalOrder.data.orderInfo.customer.shippingAddress.houseNumberOrName === 'string') &&
            typeof obj.paypalOrder.data.orderInfo.customer.shippingAddress.city === 'string' &&
            typeof obj.paypalOrder.data.orderInfo.customer.shippingAddress.zipCode === 'string' &&
            (typeof obj.paypalOrder.data.orderInfo.customer.shippingAddress.stateProvince === 'undefined' ||
              obj.paypalOrder.data.orderInfo.customer.shippingAddress.stateProvince === null ||
              typeof obj.paypalOrder.data.orderInfo.customer.shippingAddress.stateProvince === 'string') &&
            (typeof obj.paypalOrder.data.orderInfo.customer.shippingAddress.phone === 'undefined' ||
              obj.paypalOrder.data.orderInfo.customer.shippingAddress.phone === null ||
              typeof obj.paypalOrder.data.orderInfo.customer.shippingAddress.phone === 'string') &&
            (typeof obj.paypalOrder.data.orderInfo.customer.shippingAddress.email === 'undefined' ||
              obj.paypalOrder.data.orderInfo.customer.shippingAddress.email === null ||
              typeof obj.paypalOrder.data.orderInfo.customer.shippingAddress.email === 'string'))))) &&
    Array.isArray(obj.paypalOrder.messages) &&
    obj.paypalOrder.messages.every((e: any) => typeof e === 'string')
  );
}
